import { Helmet } from "react-helmet";
import UnifiedImage from '../../assets/img_frame_313752.webp';
import { Link } from "react-router-dom";
import { Button, Text, Heading, Img } from "../../components";
import Footer from "../../components/Footer";
import BlogSection from "./BlogSection";
import ConsultationCallToActionSection from "./ConsultationCallToActionSection";
import FAQSection from "../ContactUs/FAQSection";
import FactoryOptimizationSection from "./FactoryOptimizationSection";
import ImageRowSection from "./ImageRowSection";
import InformationSection from "./InformationSection";
import LogoRowSection from "./LogoRowSection";
import OfferingsSection from "./OfferingsSection";
import UnifiedDigitalTwinSection from "./UnifiedDigitalTwinSection";
import WhyChooseUsSection from "./WhyChooseUsSection";
import React from "react";
import Header from "components/Header";
import DemoVideoSection from "pages/Bookademo/DemoVideoSection";

export default function Home1Page() {
  return (
    <>
      <Helmet>
        <title>Digital Twin Solutions for Agile Manufacturing - Zwilling Labs</title>
        <meta
          name="description"
          content="Explore Zwilling Labs' Unified Digital Twin Platform for real-time insights and operational optimization in manufacturing. AI-driven solutions for predictive maintenance and process efficiency."
        />
      </Helmet>
      <div className="w-full bg-white">
      <Header className="rounded-bl-[34px] rounded-br-[34px]" />
        <div className="flex flex-col items-center -mt-[34px] bg-cover bg-no-repeat pt-[161px] md:h-auto md:gap-[121px] sm:gap-[81px]" style={{ backgroundImage: `url(${UnifiedImage})`}}>
          {/* <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" /> */}
          {/* Unified Digital Twin Section */}
          {/* <div className="w-full max-w-full"> */}
            <UnifiedDigitalTwinSection />
          {/* </div> */}
        </div>

        {/* Image Row Section */}
        <div className="w-full max-w-full">
          <ImageRowSection />
        </div>

        {/* Offerings Section */}
        <div className="w-full max-w-full">
          <OfferingsSection />
        </div>

        {/* Logo Row Section */}
        <div className="w-full max-w-full">
          <LogoRowSection />
        </div>

        {/* Information Section */}
        {/* <div className="w-full max-w-full">
          <InformationSection />
        </div> */}
        <div className="flex justify-center items-center w-full">
          <div className="w-[80%] max-w-full">
            <DemoVideoSection />
          </div>
        </div>


        {/* Why Choose Us Section */}
        <div className="w-full max-w-full">
          <WhyChooseUsSection />
        </div>

        {/* Factory Optimization Section */}
        <div className="w-full max-w-full">
          <FactoryOptimizationSection />
        </div>

        {/* Blog Section */}
        {/* <div className="w-full max-w-full">
          <BlogSection />
        </div> */}

        {/* Consultation Call to Action Section */}
        <div className="w-full max-w-full">
          <ConsultationCallToActionSection />
        </div>

        {/* FAQ Section */}
        <div className="w-full max-w-full">
          <FAQSection />
        </div>

        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
      </div>
    </>
  );
}
